import React from 'react'
import { Input } from '.';
import { formatAddress } from '../../helpers';
import { InputsPopup } from './InputsPopup';

export const AddressInput = ({className = '', tabIndex, value, changeHandler}) => {

  const addressValue = {...value};

  let placeholderValue = formatAddress(value) || 'Указать'

    return (
      <InputsPopup tabIndex={tabIndex} className='cell' placeholder={placeholderValue}>
          <div className="address-input">
            <Input changeHandler={(e) => changeHandler({...addressValue, village: e.target.value})} value={value.village} className='cell contrast' label='Поселок' />
            <Input changeHandler={(e) => changeHandler({...addressValue, street: e.target.value})} value={value.street} className='cell contrast' label='Улица, дом' />
            <Input changeHandler={(e) => changeHandler({...addressValue, apartmentNumber: e.target.value})} value={value.apartmentNumber} className='cell contrast' label='Квартира' placeholder='кв, этаж' />
            <Input changeHandler={(e) => changeHandler({...addressValue, additional: e.target.value})} value={value.additional} className='cell contrast' label='Дополнительно' placeholder='дмф'  />
          </div>
      </InputsPopup>
    );
}